import { z } from 'zod';
import { apiUrl } from '../config/api';
import { apiClient } from '../lib/apiClient';
import { apiResponseSchema, favouriteSchema } from '../lib/schemas';

export type Favourite = z.infer<typeof favouriteSchema>;

export interface CreateFavouriteRequest {
  project_id: string;
  order_id?: string;
  task_id: string;
  worktype?: string | null;
  billable?: boolean;
}

const favouritesArraySchema = z.array(favouriteSchema);

export const favouriteService = {
  async getFavourites(): Promise<Favourite[]> {
    const result = await apiClient.get(apiUrl.favourites(), {
      validate: apiResponseSchema(favouritesArraySchema),
      deduplicate: true,
      context: 'getFavourites',
    });
    return result.data || [];
  },

  async createFavourite(data: CreateFavouriteRequest): Promise<Favourite> {
    const result = await apiClient.post(apiUrl.favourites(), data, {
      validate: apiResponseSchema(favouriteSchema),
      context: 'createFavourite',
    });
    return result.data;
  },

  async deleteFavourite(id: string): Promise<void> {
    await apiClient.delete(apiUrl.favourite(id), {
      context: 'deleteFavourite',
    });
  },
};

